import axios from 'axios';
import {lstorage} from 'utils/lstorage.js';
import {web3} from 'decentralized/web3.js';
import ipfsClient from 'decentralized/Ipfs.js';
import ethereum from 'decentralized/ethereum.js';
import Item from './Item.js';

class Sequence extends Item {
    constructor(decentralized, sequenceId, ipfsHash, data, title) {
        super();
        this.decentralized = decentralized;
        this.ipfsHash = ipfsHash;
        this.sequenceId = sequenceId;
        this.data = data;
        this.title = title;
    }

    getName() {
        return this.title;
    }

    getId() {
        return this.ipfsHash;
    }

    save(title, json, previousSequence, samples, postToEthereum, noUTF, bpm) {
        return new Promise(async (resolve, reject) => {
            // 1. upload to ipfs
            // 2. get ipfs hash
            // 3. save ipfs hash and title to ethereum
            
            let hash = await ipfsClient.addJson(json, undefined, noUTF);
            // download it again to make sure it did it
            let _json = undefined;
            while (!_json) {
                try {
                    _json = await ipfsClient.getJson();
                    if (_json) {
                        break;
                    }
                    console.log("getting json again cuz of error");
                    hash = await ipfsClient.addJson(json, undefined, noUTF);
                } catch (e) {
                    _json = undefined;
                    console.log("getting json again cuz of error");
                }
            }
            resolve({ipfsHash: hash});
            if (title !== 'export') {
                this.saveToLocalStorage(title, hash);
            }
            if (postToEthereum) {
                ethereum.saveNewSequence(previousSequence, hash, title, samples, bpm);
            }
        });
    }

    async saveToLocalStorage(title, hash) {
        if (!title || title === "") {
            return;
        }

        let sequences = lstorage.getItem('sequences');
        if (sequences) {
            sequences = JSON.parse(sequences);
        } else {
            sequences = [];
        }
        let blockNumber = await web3.eth.getBlockNumber();
        sequences = [{title: title, hash: hash, blockNumber}, ... sequences];

        lstorage.setItem('sequences', JSON.stringify(sequences));
    }

    loadTitle() {
        return new Promise((resolve, reject) => {
            console.log('loading title for ipfshash = ' + this.ipfsHash);
            ethereum.tokenizedSequences.getSequence(this.ipfsHash)
                .then(s => resolve(s[0] &&  s[0].title));
        });
    }

    load() {
        console.log("load called with this =", this);
        // return json using either the ipfs hash 
        return new Promise((resolve, reject) => {
            if (this.data) {
                resolve(JSON.parse(this.data));
                return;
            }
            if (this.decentralized && this.ipfsHash !== undefined) {
                console.log("ipfs hash = ", this.ipfsHash);
                ipfsClient.getJson(this.ipfsHash)
                    .then(ret => resolve(ret));
            } else {
                axios.get('/sequence/' + this.sequenceId)
                    .then((ret) => resolve(ret.data.data));
            }
        });
    }
}

export default Sequence;
